module.exports = __webpack_public_path__ + "kudos_82.svg?6e4f39f86497e748ea0ed7384df43419";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_82.svg
// module id = 186
// module chunks = 0